import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=124b5cf9&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports